module.exports = __webpack_public_path__ + "static/media/h12_mtev_bw.ba07ffec.webp";